// DevPanel — local dev mode switcher. Renders NOTHING unless the server answered /api/dev/status
// (only possible when the local machine has .dev.env). Lets this tab act as a dev identity:
// merchant, employee or a customer — each isolated tab/window can be a different person.

import { useState } from 'react';
import type { JSX } from 'react';
import { useDevState, activeDevIdentity, setActiveDevIdentity } from './dev-store.ts';
import './DevPanel.css';

export const DevPanel = (): JSX.Element | null => {
  const state = useDevState();
  const [open, setOpen] = useState(false);
  if (state.status === null) return null;
  const active = activeDevIdentity(state);

  return (
    <div className="dev-panel" data-open={open}>
      <button
        type="button"
        className="dev-panel-toggle"
        aria-expanded={open}
        aria-controls="dev-panel-list"
        onClick={() => setOpen(!open)}
      >
        <span className="dev-panel-badge">DEV</span>
        <span className="dev-panel-who">{active?.label ?? 'Not connected'}</span>
      </button>
      {open && (
        <div id="dev-panel-list" className="dev-panel-list" role="radiogroup" aria-label="Act as dev identity">
          {state.status.identities.map((d) => (
            <button
              key={d.key}
              type="button"
              role="radio"
              aria-checked={active?.key === d.key}
              className="dev-panel-item"
              onClick={() => { setActiveDevIdentity(d.key); setOpen(false); }}
            >
              <span className="dev-panel-item-label">{d.label}</span>
              <span className="dev-panel-item-meta">{d.handle ?? `${d.address.slice(0, 8)}…`}</span>
            </button>
          ))}
          {active !== null && (
            <button type="button" className="dev-panel-item dev-panel-disconnect" onClick={() => { setActiveDevIdentity(null); setOpen(false); }}>
              Disconnect dev identity
            </button>
          )}
          <p className="dev-panel-note">Local dev mode — payments are mocked and confirm instantly.</p>
        </div>
      )}
    </div>
  );
};
